module.exports = __webpack_public_path__ + "media/components/src/assets/images/embellishments/gifts/gift_03-e3db3d2acf0feb23353f7acc7de9deee.svg";